const DIMENSIONS = [
    'width',
    'height'
];
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
export default function (obj) {
    let style = [];
    for (let prop in obj) {
        let val = obj[prop];
        if (DIMENSIONS.indexOf(prop) !== -1 && val) {
            style.push(isNumeric(val) ? `${prop}:${val}px` : `${prop}:${val}`);
        }
        else if (val) {
            style.push(`${prop}:${val}`);
        }
    }
    return style.join(';');
}
